import MeasurementPage from '@components/MeasurementPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'weight'

export default function WeightPage() {
  const submit = useSubmit()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (
    value: string,
    unit: string,
    event: React.FormEvent<HTMLFormElement>,
  ) => {
    const answer = {
      question_key: QUESTION_KEY,
      question: 'What is your weight?',
      answer_key: value.toLowerCase(),
      answer: `${value} ${unit}`,
    }

    const formData = new FormData(event.currentTarget)
    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <MeasurementPage
      heading="pages.onboarding.weight.heading"
      description="pages.onboarding.weight.description"
      placeholders={{ kg: '70', lb: '155' }}
      units={['kg', 'lb']}
      defaultUnit="kg"
      onSubmit={handleSubmit}
      preselectedValue={preselectedValue}
    />
  )
}
